import { render, staticRenderFns } from "./TypeForm.vue?vue&type=template&id=56a0576e&scoped=true"
import script from "./TypeForm.vue?vue&type=script&lang=js"
export * from "./TypeForm.vue?vue&type=script&lang=js"
import style0 from "./TypeForm.vue?vue&type=style&index=0&id=56a0576e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a0576e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56a0576e')) {
      api.createRecord('56a0576e', component.options)
    } else {
      api.reload('56a0576e', component.options)
    }
    module.hot.accept("./TypeForm.vue?vue&type=template&id=56a0576e&scoped=true", function () {
      api.rerender('56a0576e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/form/TypeForm.vue"
export default component.exports